import { renderTextLineClamp } from 'helpers';
import { formatDecimalValue } from 'modules/order/common/helpers';

export const renderPrice = <Row extends object>(
  item: Row,
  field: keyof Row
) => {
  const price = item[field];

  if (typeof price === 'string') {
    const value = formatDecimalValue(price);
    return renderTextLineClamp(value);
  }
  return null;
};
